module.exports = __webpack_public_path__ + "media/images/ic-pin-red-fullfiled-7045d36e1426d81139e046c2a37fe467.svg";